












import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import router, { ROUTES } from "../router";

@Component
export default class BackButton extends Vue {
  @Prop()
  private routeName?: string;
  @Prop()
  private params?: string | undefined;

  get route(): string {
    return this.routeName || ROUTES.home;
  }
  private goBack() {
    if (this.params != undefined) {
      router.push({
        name: this.route || ROUTES.home,
        params: { contactId: this.params.toString() }
      });
    } else router.push({ name: this.route || ROUTES.home });
  }
}
